import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const PlayerRankWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const PlayerRankContainer = styled.div`
  border: 1px solid ${theme.colors.AccentNaplesYellow};
  border-radius: 8px;
  padding: 8px 16px;
  text-align: center;
`;
